export enum MIXPANEL_EVENT_PROPERTIES {
    SOURCE_PAGE = 'Source Page',
    LISTINGS_TYPE = 'Listings Type',
    SEARCH_QUERY = 'Search Query',
    BRAND_NAME = 'Brand Name',
    BRAND_NAME_FILLED = 'Brand Name Filled',
    CTA_POSITION = 'CTA position',
    SLOGAN = 'Slogan',
    INDUSTRY = 'Industry',
    INDUSTRY_COUNT = 'Industry Count',
    RELATED_INDUSTRY_COUNT = 'Related Industry Count',
    KEYWORDS = 'Keywords',
    KEYWORDS_COUNT = 'Keywords Count',
    STYLE = 'Style',
    STYLE_COUNT = 'Style Count',
    ENTRY_POINT_CLICKED = 'Entry point Clicked',
    USER_STATE = 'User State',
    FILTER_LOCATION = 'Filter Location',
    FILTER = 'Filter',
    FILTER_ACTION = 'Filter Action',
    VALUE = 'Value',
    VIA_CAROUSEL = 'Via Carousel',
    CHANGE_LOCATION = 'Change Location',
    FIELD = 'Field',
    LOCATION = 'Location',
    PACKAGE = 'Package',
    PRICE = 'Price',
    LOGO_POSITION = 'Logo Position',
    VARIATION_POSITION = 'Variation Position',
    SELLER_ID = 'Seller ID',
    PROJECT_ID = 'Project ID',
    VARIATION_ID = 'Variation ID',
    ORDER_ID = 'Order ID',
    DRAFT_ID = 'Draft ID',
    ENGINE_TYPE = 'Engine Type',
    ALGO_SOURCE = 'Algo Source',
    SYMBOL_QUALITY = 'Symbol Quality',
    VARIATION_QUALITY = 'Variations Quality',
    RPI = 'RPI',
    ELEMENTS = 'Elements',
    TAG = 'Tag',
    TAG_TYPE = 'Tag Type',
    CLASSIC_OR_MODERN = 'Classic-Modern',
    ACCESSIBLE_OR_LUXURIOUS = 'Accessible-Premium',
    FUN_OR_SERIOUS = 'Fun-Serious',
    SIMPLE_OR_SOPHISTICATED = 'Simple-Sophisticated',
    TRADITIONAL_OR_INNOVATIVE = 'Traditional-Innovative',
    LOGO_TYPE = 'Logo Type',
    LOGO_STYLE = 'Logo Style',
    BRIEF_SOURCE = 'Brief Source',
    REFERRER = 'Referrer',
    REFERRER_URL = 'referrerUrl',
    FROM_BOOST = 'fromBoost',
    QUESTION_CLICKED = 'Question clicked',
    ARTICLE_TITLE = 'Article Title',
    HORIZONTAL_POSITION = 'Horizontal Position',
    ACTION = 'Action',
    ACTION_TYPE = 'Action Type',
    SECTION = 'Section',
    PAGE_TYPE = 'Page Type',
    PAGE_PATH = 'Page Path',
    BRIEF_ID = 'Brief ID',
    ORDER_TYPE = 'Order Type',
    USER_ACTIVATED = 'User Activated',
    NUMBER_OF_VARIATIONS = 'Number of Variations',
    EDITED = 'Edited',
    NAVIGATION_SOURCE = 'Navigation Source',
    OFFER_DISPLAYED = 'Upgrade Limited Offer Displayed',
    SELLER_CARD_DISPLAYED = 'Seller Card displayed',
    NUMBER_OF_SELECTED_PROJECTS = 'Number Of Selected Projects',
    SELECTED_PROJECTS = 'Selected Projects',
    PROJECT_NAME = 'Project Name',
    SERVICE_NAME = 'Service Name',
    NEW_BRAND_NAME = 'New Brand Name',
    IS_FREE = 'Is free',
    PACKAGE_TYPE = 'Package',
    VARIATION_NUMBER = 'Variation Number',
    NUMBER_OF_FILTERED_LOGOS = 'Number of Filtered Logos',
    NUMBER_OF_DRAFTS = 'Number of Drafts',
    NUMBER_OF_ORDERS = 'Number of Orders',
    NUMBER_OF_FAVORITES = 'Number of Favorites',
    STEP = 'Step',
    CTA_CLICKED = 'CTA Clicked',
    POSITION = 'Position',
    PAGE = 'Page',
    VARIATION_TYPE = 'Variation type',
    TAGGED_LOGO_STYLE = 'Tagged Logo Style',
    EXTRA_ENGINES = 'Extra Engines',
    VARIATIONS_QUALITY = 'Variations Quality',
    TAB = 'Tab',
    TR_TIER = 'TR Tier',
    BANNER_NAME = 'Banner Name',
    LAYOUT = 'Layout',
    COLUMN = 'Column',
    ORDER = 'Order',
    RATING = 'Rating',
    REVIEW = 'Review',
}

export enum MIXPANEL_GENERIC_EVENTS {
    PAGE_VIEW = 'Logo Maker Page View',
    PAGE_ACTION = 'Logo Maker Page Action',
}

export enum ACTION_NAMES {
    CLICKED_ARTICLE = 'Clicked Article',
    START_BRIEF = 'Start Brief',
    IDEAS_HUB_INTERACTION = 'Ideas Hub Interaction',
    CHOOSE_VARIATION_SELLER_CLICK_ACTION = 'Choose variation seller click',
}

export enum BRIEF_SOURCE {
    MP_BRIEF = 'MP Brief',
    LM_BRIEF = 'LM Brief',
}
